export default __webpack_public_path__ + "static/media/ttac2.632a7d18.svg";